// adapted from: https://github.com/marmelab/react-admin/blob/master/packages/ra-ui-materialui/src/layout/Confirm.js because we don't want the icons attached to each button
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import ActionCheck from '@material-ui/icons/CheckCircle';
import classnames from 'classnames';
import { compose } from 'recompose';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { fade } from '@material-ui/core/styles/colorManipulator';
import MuiButton from '@material-ui/core/Button';
import { withStyles, createStyles } from '@material-ui/core/styles';
import { translate } from 'react-admin';

const styles = theme =>
  createStyles({
    contentText: {
      minWidth: 400,
    },
    confirmPrimary: {
      color: theme.palette.primary.main,
    },
    confirmWarning: {
      color: theme.palette.error.main,
      '&:hover': {
        backgroundColor: fade(theme.palette.error.main, 0.12),
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: 'transparent',
        },
      },
    },
    iconPaddingStyle: {
      paddingRight: '0.5em',
    },
  });

/**
 * Confirmation dialog
 *
 * @example
 * <Confirm
 *     isOpen={true}
 *     title="Delete Item"
 *     content="Are you sure you want to delete this item?"
 *     confirm="Yes"
 *     confirmColor="primary"
 *     cancel="Cancel"
 *     onConfirm={() => { // do something }}
 *     onClose={() => { // do something }}
 * />
 */
class Confirm extends Component {
  state = { loading: false };

  handleConfirm = e => {
    e.stopPropagation();
    this.setState({ loading: true });
    this.props.onConfirm();
  };

  render() {
    const {
      isOpen,
      title,
      content,
      confirm,
      cancel,
      confirmColor,
      onClose,
      classes,
      translate,
      translateOptions = {},
    } = this.props;
    const { loading } = this.state;

    return (
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">
          {translate(title, { _: title, ...translateOptions })}
        </DialogTitle>
        <DialogContent id="confirm-dialog-description">
          <DialogContentText className={classes.contentText}>
            {translate(content, {
              _: content,
              ...translateOptions,
            })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MuiButton disabled={loading} onClick={onClose}>
            {translate(cancel, { _: cancel })}
          </MuiButton>
          <MuiButton
            disabled={loading}
            onClick={this.handleConfirm}
            className={classnames('ra-confirm', {
              [classes.confirmWarning]: confirmColor === 'warning',
              [classes.confirmPrimary]: confirmColor === 'primary',
            })}
            autoFocus
          >
            {/* <ActionCheck className={classes.iconPaddingStyle} /> */}
            {translate(confirm, { _: confirm })}
          </MuiButton>
        </DialogActions>
      </Dialog>
    );
  }
}

Confirm.propTypes = {
  cancel: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  confirm: PropTypes.string.isRequired,
  confirmColor: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
};

Confirm.defaultProps = {
  cancel: 'ra.action.cancel',
  classes: {},
  confirm: 'ra.action.confirm',
  confirmColor: 'primary',
  isOpen: false,
};

export default compose(
  withStyles(styles),
  translate
)(Confirm);
